import React, { useEffect, useContext, useState } from "react";
import moment from "moment";
import AdminLayout from "./AdminLayout";
import AdminContext from "../../context/adminContext/adminContext";
import AuthContext from "../../context/authContext/authContext";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));
const Facturacion = (props) => {
  const adminContext = useContext(AdminContext);
  const { getAllPedidos, historial } = adminContext;
  const authContext = useContext(AuthContext);
  const { cliente } = authContext;
  const [fecha, setfecha] = useState();
  const [resultado, setResultado] = useState();
  const [busqueda, setbusqueda] = useState(null);
  const [totalMes, settotalMes] = useState(0);
  const [totalMesMP, settotalMesMP] = useState(0);
  const [dia, setdia] = useState([]);
  const [diaMes, setdiaMes] = useState();
  const [picker, setpicker] = useState(null);
  const [isloading, setisloading] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    if (cliente) {
      if (cliente.admin === "false") {
        props.history.push("/client");
      }
      if (
        cliente.nombre === "agus mesera" ||
        cliente.nombre === "mesera" ||
        cliente.nombre === "mesera2"
      ) {
        props.history.push("/admin/salon");
      }
    }
    // eslint-disable-next-line
  }, [cliente]);
  useEffect(() => {
    if (historial.length > 1) setisloading(false);
    if (historial.length > 0) {
      if (busqueda !== null) {
        const filtro = historial.filter((pedido) => {
          let año = pedido.fecha.split(" ")[0].split("/")[2];
          let mes = pedido.fecha.split(" ")[0].split("/")[1];
          let fecha = `${mes} ${año}`;

          return fecha === busqueda;
        });
        setResultado(filtro);
        let dias = [];
        let elMes = 0;
        let elMesMP = 0;
        filtro.forEach((element) => {
          let dia = element.fecha.split(" ")[0].split("/")[0];
          let mes = element.fecha.split(" ")[0].split("/")[1];
          dias.push({
            dia: dia,
            efectivo:
              element.forma_pago === "efectivo" ? element.precio_total : 0,
            tarjeta:
              element.forma_pago !== "efectivo" ? element.precio_total : 0,
          });
          if (mes === busqueda.split(" ")[0]) {
            if (element.forma_pago === "efectivo") {
              elMes += element.precio_total;
            } else {
              elMesMP += element.precio_total;
            }
          }
        });
        //OBTENER FACTURACION POR DIA
        const unicos = dias.reduce((acc, item) => {
          if (acc.length === 0) {
            acc.push(item);
          } else {
            let idx = acc
              .map((a) => {
                return a.dia;
              })
              .indexOf(item.dia);
            if (idx > -1) {
              acc[idx].efectivo += item.efectivo;
              acc[idx].tarjeta += item.tarjeta;
            } else {
              acc.push(item);
            }
          }

          return acc;
        }, []);

        setdia(unicos);
        settotalMes(elMes);
        settotalMesMP(elMesMP);
        setisloading(false);
      }
    }
    // eslint-disable-next-line
  }, [busqueda, historial]);
  const handleDateChange = (date) => {
    let fecha = date._d.toString();
    let year = date._d.toString().split(" ")[3];
    let month = date._d.toString().split(" ")[1];
    let days = Array.from(Array(moment(date).daysInMonth()), (_, i) => i + 1);
    setdiaMes(days);
    if (month === "Dec") month = "12";
    if (month === "Jan") month = "01";
    if (month === "Feb") month = "02";
    if (month === "Mar") month = "03";
    if (month === "Apr") month = "04";
    if (month === "May") month = "05";
    if (month === "Jun") month = "06";
    if (month === "Jul") month = "07";
    if (month === "Aug") month = "08";
    if (month === "Sep") month = "09";
    if (month === "Oct") month = "10";
    if (month === "Nov") month = "11";
    setpicker(date);
    setbusqueda(`${month} ${year}`);
    setfecha(fecha);
  };
  useEffect(() => {
    setisloading(true);
    getAllPedidos();

    // eslint-disable-next-line
  }, []);

  return (
    <AdminLayout>
      <Container>
        <Backdrop className={classes.backdrop} open={isloading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Typography variant="h3" align="center">
          Facturación
        </Typography>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker
              margin="normal"
              id="date-picker-dialog"
              views={["year", "month"]}
              label="Elija Mes y Año"
              format="MM/YYYY"
              value={picker}
              disableFuture={true}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>
        </div>
        {busqueda ? (
          <Typography gutterBottom={true} variant="h4">
            {busqueda.split(" ")[0] === "12"
              ? `Diciembre ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "11"
              ? `Noviembre ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "01"
              ? `Enero ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "02"
              ? `Febrero ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "03"
              ? `Marzo ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "04"
              ? `Abril ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "05"
              ? `Mayo ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "06"
              ? `Junio ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "07"
              ? `Julio ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "08"
              ? `Agosto ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "09"
              ? `Septiembre ${busqueda.split(" ")[1]}`
              : busqueda.split(" ")[0] === "10"
              ? `Octubre ${busqueda.split(" ")[1]}`
              : null}
          </Typography>
        ) : null}
        <div style={{ width: "100%", display: "flex", flexWrap: "wrap" }}>
          {diaMes
            ? diaMes.map((d) => {
                return (
                  <Card style={{ width: "14.28%", height: "180px" }}>
                    <CardContent>
                      <Typography gutterBottom variant="h4">
                        {d}
                      </Typography>
                      {dia.map((di) => {
                        if (di.dia === d.toString()) {
                          return (
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                justifyContent: "flex-end",
                                alignItems: "flex-end",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                >
                                  E:{" "}
                                </Typography>
                                <Typography variant="h6">
                                  ${di.efectivo}
                                </Typography>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                >
                                  MP:{" "}
                                </Typography>
                                <Typography variant="h6">
                                  ${di.tarjeta}
                                </Typography>
                              </div>
                            </div>
                          );
                        }
                        return null;
                      })}
                    </CardContent>
                  </Card>
                );
              })
            : null}
        </div>

        <div
          style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}
        >
          {busqueda ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                alignContent: "flex-end",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle1">Tarjeta : </Typography>
                <Typography variant="h5">${totalMesMP}</Typography>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "1rem",
                }}
              >
                <Typography variant="subtitle1">Efectivo :</Typography>
                <Typography variant="h5"> ${totalMes}</Typography>
              </div>

              <Typography variant="h4">
                TOTAL : ${totalMesMP + totalMes}
              </Typography>
            </div>
          ) : null}
        </div>
      </Container>
    </AdminLayout>
  );
};

export default Facturacion;
